<template>
  <div class="loader" style="text-align: center; margin: 50px">
    <img src="../assets/loading.gif" width="40" al="loading" />
  </div>
</template>